import React, { useState } from "react";
import "../css/login.css";
import { NavLink, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { backend_url } from "../App.js";

function Login() {
    const navigate = useNavigate();
    const [data, setData] = useState({
        email: "",
        password: "",
    });
    
    const [error, setErrorMessage] = useState('');
    
    let getMongoRows = async (uid) => {
        try {
            // Get the expense rows of the user
            const expenseRow = await axios.post(backend_url + 'getExpenseRow', {userID: uid});

            // Get the income total of the user
            const incomeTotal = await axios.post(backend_url + 'getSummary', {userID: uid, type: 'incomeTotal'});
            // Get the expense totals of the user
            const liveTotal = await axios.post(backend_url + 'getSummary', {userID: uid, type: 'liveTotal'});
            const giveTotal = await axios.post(backend_url + 'getSummary', {userID: uid, type: 'giveTotal'});
            const growTotal = await axios.post(backend_url + 'getSummary', {userID: uid, type: 'growTotal'});
            const oweTotal = await axios.post(backend_url + 'getSummary', {userID: uid, type: 'oweTotal'});
            
            //Set session storage items for Expense table rows
            sessionStorage.setItem('expenseTableRows', JSON.stringify(expenseRow.data.data));
            sessionStorage.setItem('prevSort', "None")
            sessionStorage.setItem('nextSort', "Greatest")
            
            //Set session storage values for Summary page's totals
            handleData(incomeTotal.data, 'income_value');
            handleData(liveTotal.data, 'liveTotal');
            handleData(giveTotal.data, 'giveTotal');
            handleData(growTotal.data, 'growTotal');
            handleData(oweTotal.data, 'oweTotal');            

        } catch (error) {
            console.error(error);
        }
    };
    
    // Handles setting the data's session storage
    const handleData = (data, key) =>{
        if (data.data.length > 0) 
        {
            sessionStorage.setItem(key, data.data[0].financeTotal);
            sessionStorage.setItem(key + 'Exists', 1);
        }
        else 
        {
            sessionStorage.setItem(key, 'Exists', 0);
            sessionStorage.setItem(key, 0)
        }
    }

    // Handles what happens when the login fields change
    const handleChange = ({ currentTarget: input }) => {
        setData({ ...data, [input.name]:input.value });
    }
        
    // Handles what happens when the user submits the form
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // Send a request to the backend to authenticate user
            const response = await axios.post(backend_url + "findUsers", data);
            const { data: responseData } = response;

            // Checks that the user is verified
            if (responseData.data.verified !== true) {
                setErrorMessage("You need to verify your account before being able to sign in");
            }
            else {
                // If they are, get their data and navigate to the summary page
                sessionStorage.setItem("userID", responseData.data.userID);
                await getMongoRows(sessionStorage.getItem('userID')); 
                window.location.href = "/summary"
            }
        } 
        catch (error) {
            console.log(error)
            if (error.response && error.response.status >= 400 && error.response.status <= 500) {
                setErrorMessage(error.response.data.message);
            }
        }
    };
    //show or hide password
    const [state, setState] = useState(false);

    const toggleBtn = () => {
        setState(prevState => !prevState);
    }

    return (
        <>
                <>
                    <meta charSet="UTF-8" />
                    <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
                    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                    <title>Sign in/Sign Up</title>
                    <link href='https://unpkg.com/boxicons@2.1.4/css/boxicons.min.css' rel='stylesheet' />
                    <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;600;700&display=swap"
                        rel="stylesheet" />
                    <link rel="preconnect" href="https://fonts.googleapis.com" />
                    <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
                </>

                    <section className="container">
                        <div className="form login">
                            <div className="form-content">
                                <header>Login</header>
                                {error && <div style={{color: "red", textAlign: "center", paddingTop: "15px"}}>{error}</div>} 
                                <form action="#" onSubmit={handleSubmit}>
                                    <div className="field input-field">
                                        <label for="email" class="visuallyhidden">E-mail</label>
                                        <input type="email" placeholder="Email" className="input" name = "email" value={data.email} onChange={handleChange} required />
                                    </div>

                                    <div className="field input-field">
                                        <label for="password" class="visuallyhidden">Password</label>
                                        <input type={state ? "text" : "password"} placeholder="Password" className="password" name="password" value={data.password} onChange={handleChange} required />
                                        <div onClick={toggleBtn}>
                                            <i className={state ? "bx bx-show eye-icon" : "bx bx-hide eye-icon"}></i>
                                        </div>
                                    </div>

                                    <div className="form-link">
                                        <NavLink to="/forgotPassword" className="forgot-pass">Forgot password?</NavLink>
                                    </div>

                                    <div className="field button-field">
                                        <button type="submit">Login</button>
                                    </div>

                                    <div className="form-link">
                                        <span>Don't have an account? <Link to='/Register' className="link sign-up-link">Sign Up</Link></span>
                                    </div>
                                
                                </form>
                            </div>
                        </div>
                    </section>
        </>
    );
}

export default Login;